import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChatImageLightbox } from './ChatImageLightbox';

type Props = {
  src: string;
  alt?: string;
};

/**
 * チャット履歴内の添付画像サムネイル。クリックでライトボックスを開く。
 * src は配信プロキシ経由の参照URL（Cookie 認証で表示される）。
 */
export function ChatImageThumbnail({ src, alt }: Props) {
  const { t } = useTranslation();
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="mb-1 mr-1 inline-block size-24 overflow-hidden rounded border border-gray-200"
        // alt（ファイル名）が無い場合でもボタンにアクセシブルネームを付与する
        aria-label={alt || t('viewModel.aiChat.viewImageLabel')}
        onClick={() => setIsLightboxOpen(true)}
      >
        <img src={src} alt={alt ?? ''} className="size-full object-cover" />
      </button>
      {isLightboxOpen && <ChatImageLightbox src={src} alt={alt} onClose={() => setIsLightboxOpen(false)} />}
    </>
  );
}
